import { render, staticRenderFns } from "./onlinecourse.vue?vue&type=template&id=053275e4"
import script from "./onlinecourse.vue?vue&type=script&lang=js"
export * from "./onlinecourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports